const MINECRAFT_LEVEL_TYPE = 'select[data-name="level-type"]';

export class MinecraftCustomSettingsUI {
  public constructor(private $base: JQuery, public data: any) {
  }

  public onLevelTypeChange(callback: (value: string, target: JQuery) => void) {
    this.$base.parents('[data-configuration-form]')
      .find(MINECRAFT_LEVEL_TYPE)
      .on('change', (e: JQuery.TriggeredEvent) => {
      const val = e.currentTarget.value;
      callback(val, e.currentTarget);
    });
  }

  public hideCustomLevelType() {
    this.$base.hide('fast');
  }

  public showCustomLevelType() {
    this.$base.show('fast');
  }

  public getLevelTypeValue(): string {
    return this.$base.parents('[data-configuration-form]')
      .find(MINECRAFT_LEVEL_TYPE)
      .val()
      .toString();
  }

  public render() {
    return new Promise((resolve) => {
      resolve();
    });
  }
}
